import React from 'react';
import './TypingIndicator.css';

const TypingIndicator = () => {
  return (
    <div className="typing-indicator">
      <div className="typing-content">
        <div className="typing-avatar">🔧</div>
        <div className="typing-bubble">
          <div className="typing-text">Generating response...</div>
          <div className="typing-dots">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;